import {component} from '../form/Constant'
import {convertKeyToLabel} from '../table-utils/TableUtils'

export const examinationKeys = {
    consultation: 'consultation',
    mri: 'mri',
    ctScan: 'ctScan',
    pathology: 'pathology',
    optical: 'optical',
    audiology: 'audiology',
    stockholm: 'stockholm',
}

export const bloodsTestsTypeOptions = [
    {
        label: 'U/E (Urea And Electrolytes)',
        value: 'ue',
    },
    {
        label: 'LFT (Liver Function Tests)',
        value: 'lft',
    },
    {
        label: 'GGT (Gamma-glutamyltransferase Test)',
        value: 'ggt',
    },
    {
        label: 'Bone',
        value: 'bone',
    },
    {
        label: 'Glucose',
        value: 'glucose',
    },
    {
        label: 'FBC (Full Blood Count)',
        value: 'fbc',
    },
    {
        label: 'HbA1c (Blood Sugar Checks)',
        value: 'hba1c',
    },
    {
        label: 'CRP (C Reactive Protein)',
        value: 'crp',
    },
    {
        label: 'ESR (Erythrocyte Sedimentation Rate)',
        value: 'esr',
    },
    {
        label: 'Full Lipid Profile',
        value: 'fullLipidProfile',
    },
    {
        label: 'TFTs (Thyroid Function Tests)',
        value: 'tfts',
    },
    {
        label: '9AM Cortisol',
        value: 'cortisol',
    },
    {
        label: 'Tumour Markers',
        value: 'tumourMarkers',
    },
    {
        label: 'LDH (Lactate Dehydrogenase)',
        value: 'ldh',
    },
    {
        label: 'Autoimmune Screen',
        value: 'autoimmuneScreen',
    },
    {
        label: 'dsDNA (Anti-Double Stranded DNA)',
        value: 'dsdna',
    },
    {
        label: 'Complement',
        value: 'complement',
    },
    {
        label: 'IgE (Total) Allergy Test',
        value: 'ige',
    },
    {
        label: 'Immunoglobulins',
        value: 'immunoglobulins',
    },
    {
        label: 'Vitamin D',
        value: 'vitaminD',
    },
    {
        label: 'Amylase',
        value: 'amylase',
    },
    {
        label: 'Iron Studies',
        value: 'ironStudies',
    },
    {
        label: 'Vitamin B12',
        value: 'vitaminB12',
    },
    {
        label: 'Folate',
        value: 'folate',
    },
    {
        label: 'Urate',
        value: 'urate',
    },
    {
        label: 'Mg (Magnesium Test)',
        value: 'mg',
    },
    {
        label: 'Creatinine Kinase',
        value: 'creatinineKinase',
    },
    {
        label: 'Troponin',
        value: 'troponin',
    },
    {
        label: 'BNP (B-type natriuretic peptide)',
        value: 'bnp',
    },
    {
        label: 'D-Dimer',
        value: 'dDimer',
    },
    {
        label: 'Clotting Screen',
        value: 'clottingScreen',
    },
    {
        label: 'Lipoprotein (a)',
        value: 'lipoproteinA',
    },
    {
        label: 'Aldosterone / Renin Ratio',
        value: 'aldosteroneReninRatio',
    },
    {
        label: 'Zinc, Copper, Selenium',
        value: 'zincCopperSelenium',
    },
    {
        label: 'SHBG (Sex Hormone Binding Globulin)',
        value: 'shbg',
    },
    {
        label: 'HIV (Human Immunodeficiency Virus)',
        value: 'hiv',
    },
    {
        label: 'Hepatitis A / Hepatitis B / Hepatitis C',
        value: 'hepatitis',
    },
    {
        label: 'LH (Luteinising Hormone)',
        value: 'lh',
    },
    {
        label: 'FSH (Follicle Stimulating Hormone)',
        value: 'fsh',
    },
    {
        label: 'Beta-HCG (Ectopic pregnancy BHCG βHCG)',
        value: 'bhcg',
    },
    {
        label: 'Testosterone',
        value: 'testosterone',
    },
    {
        label: 'Prolactin',
        value: 'prolactin',
    },
]

export const otherTestsTypeOptions = [
    {
        label: 'ECG (Electrocardiogram)',
        value: 'ecg',
    },
    {
        label: 'ECHO (Echocardiogram)',
        value: 'echo',
    },
    {
        label: '24hr ECG',
        value: '24hrEcg',
    },
    {
        label: '24hr BP',
        value: '24hrBp',
    },
    {
        label: 'Colonoscopy',
        value: 'colonoscopy',
    },
    {
        label: 'FIT (Faecal Immunochemical Test)',
        value: 'fit',
    },
    {
        label: 'Calprotectin',
        value: 'calprotectin ',
    },
    {
        label: 'Stool Culture',
        value: 'stoolCulture ',
    },
    {
        label: 'Sputum Cytology',
        value: 'sputumCytology ',
    },
    {
        label: 'Urine Dip (including protein and glucose)',
        value: 'urineDip ',
    },
    {
        label: 'MSU (Midstream Specimen of Urine) and Cytology',
        value: 'msu ',
    },
    {
        label: 'Microalbumin (Random urine)',
        value: 'microalbumin',
    },
]

export const radiologyOptions = [
    {
        value: 'mriBrain',
        label: 'MRI Brain',
    },
    {
        value: 'ctChestAbdomenPelvis',
        label: 'CT Chest Abdomen Pelvis',
    },
    {
        value: 'usLiverAndRenalTract',
        label: 'US Liver and Renal Tract',
    },
    {
        value: 'ctCoronaryArteriogram',
        label: 'CT Coronary Arteriogram',
    },
    // {
    //     value: 'mriProstate',
    //     label: 'MRI prostate for Male',
    // },
    // {
    //     value: 'mammogram',
    //     label: 'Mammogram for Female',
    // },
    // {
    //     value: 'transvaginalUs',
    //     label: 'Transvaginal US for Female',
    // },
]

export const examinationList = [
    {
        key: 'generalTestingInformation',
        description:
            'Fill in the following information to create a examination.',
        children: [
            {
                key: examinationKeys.consultation,
                label: convertKeyToLabel(examinationKeys.consultation),
                component: component.inputTextArea,
                placeholder: "Input patient's Consultation here (Optional)",
                defaultValue: '',
            },
            {
                key: examinationKeys.mri,
                label: 'MRI (Magnetic Resonance Imaging)',
                component: component.inputTextArea,
                placeholder: "Input patient's MRI here (Optional)",
                defaultValue: '',
            },
            {
                key: examinationKeys.ctScan,
                label: 'CT Scan (Computerised Tomography Scan)',
                component: component.inputTextArea,
                placeholder: "Input patient's CT Scan here (Optional)",
                defaultValue: '',
            },
            {
                key: examinationKeys.pathology,
                label: convertKeyToLabel(examinationKeys.pathology),
                component: component.inputTextArea,
                placeholder: "Input patient's Pathology here (Optional)",
                defaultValue: '',
            },
            {
                key: examinationKeys.stockholm,
                label: 'Stockholm3',
                component: component.inputTextArea,
                placeholder: "Input patient's Stockholm3 here (Optional)",
                defaultValue: '',
            },
            {
                key: examinationKeys.optical,
                label: convertKeyToLabel(examinationKeys.optical),
                component: component.inputTextArea,
                placeholder: "Input patient's Optical here (Optional)",
                defaultValue: '',
            },
            {
                key: examinationKeys.audiology,
                label: convertKeyToLabel(examinationKeys.audiology),
                component: component.inputTextArea,
                placeholder: "Input patient's Audiology here (Optional)",
                defaultValue: '',
            },
        ],
    },
    {
        key: 'bloodsTests',
        description:
            "A blood test is often done to check your health, or to find out why you're having certain symptoms. It involves having a small amount of your blood taken for testing.",
        children: [
            {
                key: 'bloodsTestsType',
                label: 'Bloods Tests Types',
                component: component.multiSelect,
                placeholder:
                    'Please select the types of blood tests whose results need to be filled in. (Optional)',
                options: bloodsTestsTypeOptions,
            },
            {
                key: 'psa',
                label: 'PSA (Prostate-Specific Antigen) for Male',
                component: component.inputTextArea,
                placeholder:
                    "Input patient's PSA (Prostate-Specific Antigen) here (Optional)",
                defaultValue: '',
            },
            {
                key: 'antiMullerianHormone',
                label: 'Anti-mullerian hormone (pre-menopausal) for Female',
                component: component.inputTextArea,
                placeholder:
                    "Input patient's Anti-mullerian hormone (pre-menopausal) here (Optional)",
                defaultValue: '',
            },
        ],
    },
    {
        key: 'radiology',
        description:
            'Radiology is a type of medicine specialising in the use of imaging to diagnose and treat disease seen within the body. ',
        children: [
            {
                key: 'radiologyType',
                label: 'Radiology Types',
                component: component.multiSelect,
                placeholder:
                    'Please select the types of radiology whose results need to be filled in. (Optional)',
                options: radiologyOptions,
            },
            // {
            //     key: 'mriBrain',
            //     label: 'MRI Brain',
            //     component: component.inputTextArea,
            //     placeholder: "Input patient's MRI Brain here (Optional)",
            //     defaultValue: '',
            // },
            // {
            //     key: 'ctChestAbdomenPelvis',
            //     label: 'CT Chest Abdomen Pelvis',
            //     component: component.inputTextArea,
            //     placeholder:
            //         "Input patient's CT Chest Abdomen Pelvis here (Optional)",
            //     defaultValue: '',
            // },
            // {
            //     key: 'usLiverAndRenalTract',
            //     label: 'US Liver and Renal Tract',
            //     component: component.inputTextArea,
            //     placeholder:
            //         "Input patient's US Liver and Renal Tract here (Optional)",
            //     defaultValue: '',
            // },
            // {
            //     key: 'ctCoronaryArteriogram',
            //     label: 'CT Coronary Arteriogram',
            //     component: component.inputTextArea,
            //     placeholder:
            //         "Input patient's CT Coronary Arteriogram here (Optional)",
            //     defaultValue: '',
            // },
            {
                key: 'mriProstate',
                label: 'MRI prostate for Male',
                examDate: true,
                component: component.inputTextArea,
                placeholder: "Input patient's MRI prostate here (Optional)",
                defaultValue: '',
            },
            {
                key: 'mammogram',
                label: 'Mammogram for Female',
                examDate: true,
                component: component.inputTextArea,
                placeholder: "Input patient's Mammogram here (Optional)",
                defaultValue: '',
            },
            {
                key: 'transvaginalUs',
                label: 'Transvaginal US for Female',
                component: component.inputTextArea,
                placeholder: "Input patient's Transvaginal US here (Optional)",
                defaultValue: '',
            },
        ],
    },
    {
        key: 'otherTests',
        description: 'Other common tests',
        children: [
            {
                key: 'otherTestsType',
                label: 'Orther Tests Types',
                component: component.multiSelect,
                placeholder:
                    'Please select the types of other tests whose results need to be filled in. (Optional)',
                options: otherTestsTypeOptions,
            },
        ],
    },
]

export const genderData = {
    unknown: 'unknown',
    female: 'female',
    male: 'male',
    indeterminate: 'indeterminate',
}
